import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { IrisFilesService } from '@iris/common/modules/dms/services/files.service';
import { DmsGridTemplateBase } from '../dms-grid-template-base';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { IrisFolderSvgComponent } from '@iris/common/modules/dms/components/icons/folder-svg/folder-svg.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'dms-grid-trash-bin-name-template',
  imports: [
    NgClass,
    TranslatePipe,
    MatTooltipModule,
    IrisFolderSvgComponent,
  ],
  templateUrl: './dms-grid-trash-bin-name-template.component.html',
  styleUrls: ['./dms-grid-trash-bin-name-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsGridTrashBinNameTemplateComponent extends DmsGridTemplateBase {
  private readonly filesService = inject(IrisFilesService);

  readonly previewSize = 24;
  readonly fileIcon = computed(() => this.filesService?.getIconClass(this.file()));
  readonly customIconClass = computed(() => this.folder()?.customIconClass);
  readonly showLock = computed(() => this.file()?.isLocked);
  readonly displayName = computed(() => this.data()?.originalName || this.data()?.name);

  refresh(): boolean {
    return true;
  }
}
